// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MiniatureMessageLayout__container-f3b877 {
  display: flex;
  align-items: center;
  min-width: 0; /* it needs for dots for long text */
  box-sizing: border-box;
  position: relative;
  width: 100%;
  padding-inline-end: 16px;
}

.MiniatureMessageLayout__focus-b4a7c8 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  z-index: 1;
}

.MiniatureMessageLayout__prevent-interaction-bd77ca .MiniatureMessageLayout__focus-b4a7c8 {
  cursor: default;
}

.MiniatureMessageLayout__link-d808e7 {
  opacity: 0;
}

.MiniatureMessageLayout__content-b1ffd4 {
  min-width: 0; /* it needs for dots for long text */
}

.MiniatureMessageLayout__title-d04c0d {
  color: var(--chat-bubble-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.MiniatureMessageLayout__subtitle-f9eeb8 {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--chat-bubble-text-secondary);
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.MiniatureMessageLayout__icon-f2f4c7 {
  margin-inline-end: 6px;
  fill: var(--chat-bubble-text-secondary);
  vertical-align: text-bottom;
}

.MiniatureMessageLayout__text-f89f01 {
  display: flex;
  align-items: center;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--chat-bubble-text-secondary);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/components/MiniatureMessageLayout/MiniatureMessageLayout.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,YAAA,EAAA,oCAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,wBAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,YAAA,EAAA,oCAAA;AACF;;AAEA;EACE,iCAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,wCAAA;EAEA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,sBAAA;EACA,uCAAA;EACA,2BAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,4BAAA;EACA,8CAAA;EACA,wCAAA;AAAF","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  min-width: 0; /* it needs for dots for long text */\n  box-sizing: border-box;\n  position: relative;\n  width: 100%;\n  padding-inline-end: 16px;\n}\n\n.focus {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.prevent-interaction .focus {\n  cursor: default;\n}\n\n.link {\n  opacity: 0;\n}\n\n.content {\n  min-width: 0; /* it needs for dots for long text */\n}\n\n.title {\n  color: var(--chat-bubble-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n}\n\n.subtitle {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--chat-bubble-text-secondary);\n\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.icon {\n  margin-inline-end: 6px;\n  fill: var(--chat-bubble-text-secondary);\n  vertical-align: text-bottom;\n}\n\n.text {\n  display: flex;\n  align-items: center;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--chat-bubble-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MiniatureMessageLayout__container-f3b877`,
	"focus": `MiniatureMessageLayout__focus-b4a7c8`,
	"prevent-interaction": `MiniatureMessageLayout__prevent-interaction-bd77ca`,
	"preventInteraction": `MiniatureMessageLayout__prevent-interaction-bd77ca`,
	"link": `MiniatureMessageLayout__link-d808e7`,
	"content": `MiniatureMessageLayout__content-b1ffd4`,
	"title": `MiniatureMessageLayout__title-d04c0d`,
	"subtitle": `MiniatureMessageLayout__subtitle-f9eeb8`,
	"icon": `MiniatureMessageLayout__icon-f2f4c7`,
	"text": `MiniatureMessageLayout__text-f89f01`
};
module.exports = ___CSS_LOADER_EXPORT___;
